import { useEffect, useState } from 'react';
import { BrowserRouter, Navigate, useLocation } from 'react-router-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { createPortal } from 'react-dom';
import App from './App';
import LiveChat from './modules/LiveChat';
import ReactDOM from 'react-dom/client';
import TopHeaderNav from './modules/snippets/TopHeaderNav';
import ModulesPeraBayong from './modules/promotions/promotion_modules/modules_peraBayong';
import MainNav from './modules/snippets/MainNav';
import SideContainer from './modules/snippets/SideContainer';
import Footer from './modules/Footer';
import FeaturedPromoMobile from './modules/snippets/FeaturedPromoMobile';
import { GlobalProvider, useGlobalContext } from './modules/data/GlobalContext';
import { LeaderboardProvider } from './modules/data/LeaderboardProvider';
import SearchGamesLibrary from './modules/snippets/global_functions/SearchGamesLibrary';
import { apiJSONURL } from './App';
import { handleLogout } from './modules/snippets/Logout';

// Stylesheets
import './style/style.css';
import './style/jili-rush.css';
import './style/fonts.css';
import './style/animation.css';
import './style/variables.css';
import './style/jiliquest.css';
import './style/promo.css';
import './style/mobile.css';

// Modules & Pages
import SlotsGames from './modules/pages/SlotsGames';
import Profile from './modules/profile/Profile';
import Promotions from './modules/promotions/Promotions';
import ExlusiveVIPRollingCommission from './modules/promotions/ExlusiveVIPRollingCommission';
import LotteryDraw from './modules/promotions/LotteryDraw';
import PeraOBayong from './modules/promotions/PeraOBayong';
import NewMemberPackageBonus from './modules/promotions/NewMemberPackageBonus';
import ThirdTimeACharm from './modules/promotions/ThirdTimeACharm';
import BecomeAgentMonthlyCommission from './modules/promotions/BecomeAgentMonthlyCommission';
import VVIPWeeklyRewards from './modules/promotions/VVIPWeeklyRewards';
import VIPReferralProgram from './modules/promotions/VIPReferralProgram';
import WeeklyCashback from './modules/promotions/WeeklyCashback';
import BirthdayBonus from './modules/promotions/BirthdayBonus';
import PaydayBonus from './modules/promotions/PaydayBonus';
import LiveGamesPage from './modules/pages/LiveGamesPage';
import VipLevels from './modules/pages/VipLevels';
import TNC from './modules/TNC';
import NotFound from './modules/NotFound';
import ResponsibleGaming from './modules/ResponsibleGaming';
import Sportsbookpage from './modules/pages/Sportsbookpage';
import DailyWins from './modules/promotions/DailyWins';
import AboutUs from './modules/AboutUs';
import DownloadApp from './modules/DownloadApp';
import PGGlobalCash from './modules/promotions/PGGlobalCash';
import BNGPrizeDrop from './modules/promotions/BNGPrizeDrop';
import FastSpinTournament from './modules/promotions/FastSpinTournament';
import AppPromo from './modules/AppPromo';
import FastCashoutGuarantee from './modules/promotions/FastCashoutGuarantee';
import RiesOfHeroes from './modules/promotions/RiseOfHeroes';
import { ScheduleProvider } from './modules/data/ScheduleContext';
import FrostFireClash from './modules/promotions/FrostFireClash';
import ColorGameBonanza from './modules/promotions/ColorGameBonanza';
import CashAndCard from './modules/promotions/CashAndCard';
import EvoThrone from './modules/promotions/EvoThrone';
import JiliFortuneRush from './modules/promotions/JiliFortuneRush';
import JILIQuest from './modules/promotions/JILIQuest';
import RaceToFame from './modules/promotions/RaceToFame';
import CandyLoadingPage from './modules/snippets/games/CandyLoadingPage';
import JiliRushGame from './modules/snippets/games/JiliRushGame';
import PromoSlotModal from './modules/data/PromoSlotModal';
import { LeaderboardJDBWinnerLeague } from './modules/data/LeaderboardJDBWinnerLeague';
import TopGamesRtp from './modules/snippets/TopGamesRtp';
import VertexPlay from './modules/promotions/VertexPlay';

// Private Route Component - checks if user is logged in
function PrivateRoute({ element }) {
    const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
    return isLoggedIn ? element : <Navigate to="/" replace />;
}

const promoRoute = (slug, element) => [
    { path: `/promotion/${slug}`, element },
    { path: `/app-promotion/${slug}`, element },
];

// Routes Page Pathings
export const routes = [
    { path: '/', element: <App /> },
    { path: '*', element: <NotFound /> },
    { path: '/app-promotion', element: <AppPromo /> },
    { path: '/page-not-found', element: <NotFound /> },
    { path: '/slots', element: <SlotsGames /> },
    { path: '/top-games-rtp', element: <TopGamesRtp /> },
    { path: '/live-casino', element: <LiveGamesPage /> },
    { path: '/sportsbook', element: <Sportsbookpage /> },
    { path: '/android', element: <DownloadApp /> },
    { path: '/vip', element: <VipLevels /> },
    { path: '/terms-and-conditions', element: <TNC /> },
    { path: '/about-us', element: <AboutUs /> },
    { path: '/responsible-gaming', element: <ResponsibleGaming /> },
    { path: '/promotion', element: <Promotions /> },
    { path: '/profile', element: <PrivateRoute element={<Profile />} /> },

    ...promoRoute('bng-prize-drop', <BNGPrizeDrop />),
    ...promoRoute('vertex-play', <VertexPlay />),
    ...promoRoute('daily-wins', <DailyWins />),
    ...promoRoute('vip-rolling-commission', <ExlusiveVIPRollingCommission />),
    ...promoRoute('2-30-lottery-draw', <LotteryDraw />),
    ...promoRoute('pera-o-bayong', <PeraOBayong />),
    ...promoRoute('new-member-bonus', <NewMemberPackageBonus />),
    ...promoRoute('third-time-charm-deposit-bonus', <ThirdTimeACharm />),
    ...promoRoute('agent-monthly-commission', <BecomeAgentMonthlyCommission />),
    ...promoRoute('vip-weekly-rewards', <VVIPWeeklyRewards />),
    ...promoRoute('vip-referral-program', <VIPReferralProgram />),
    ...promoRoute('weekly-cashback', <WeeklyCashback />),
    ...promoRoute('birthday-bonus', <BirthdayBonus />),
    ...promoRoute('payday-bonus', <PaydayBonus />),
    ...promoRoute('road-to-glory', <FastSpinTournament />),
    ...promoRoute('fash-cashout-guarantee', <FastCashoutGuarantee />),
    ...promoRoute('pg-global-cash', <PGGlobalCash />),
    ...promoRoute('rise-of-heroes', <RiesOfHeroes />),
    ...promoRoute('fastspin-frostfire-clash', <FrostFireClash />),
    ...promoRoute('color-game-bonanza', <ColorGameBonanza />),
    ...promoRoute('cash-and-card', <CashAndCard />),
    ...promoRoute('evo-throne', <EvoThrone />),
    ...promoRoute('jili-rush', <JiliFortuneRush />),
    ...promoRoute('jili-quest', <JILIQuest />),
    ...promoRoute('race-to-fame', <RaceToFame />),
    ...promoRoute('pg-global-cash', <PGGlobalCash />),
];
// IMPORTANT: All internal links must exclude trailing slashes.
// Example: Use /promotion/title, NOT /promotion/title/
// Applies site-wide — consistency prevents SEO and duplicate content issues.

function RootContent() {
    const { showMysteryFridayBtn, username, isLoggedIn } = useGlobalContext();

    const [activeModal, setActiveModal] = useState('');

    const [loading, setLoading] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const [showJiliRush, setShowJiliRush] = useState(false);
    const [showPromoSlot, setShowPromoSlot] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 3000);

        return () => clearTimeout(timer);
    }, []);

    // Mystery Friday Modal logic (unchanged)
    useEffect(() => {
        if (!isLoggedIn) return;

        const now = new Date();
        const day = now.getDay();
        const hour = now.getHours();
        const minute = now.getMinutes();

        const isFriday =
            day === 5 && (hour > 13 || (hour === 13 && minute >= 0));
        const isSaturday = day === 6;
        const isSunday = day === 0;
        const isMonday =
            day === 1 && (hour < 24 || (hour === 23 && minute <= 59));

        const isWithinTimeRange =
            isFriday || isSaturday || isSunday || isMonday;

        if (isWithinTimeRange && showMysteryFridayBtn) {
            setActiveModal('Pera O Bayong');
        }
    }, [showMysteryFridayBtn, username, isLoggedIn]);

    const modalComponents = {
        'Pera O Bayong': ModulesPeraBayong,
    };

    const ActiveModal = activeModal ? modalComponents[activeModal] : null;

    // Validation Session Code
    useEffect(() => {
        const checkSessionValidity = async () => {
            const sessionId = localStorage.getItem('sessionId');

            if (!username || !sessionId) return;

            try {
                const url = `${apiJSONURL}?cmd=validateSession&u=${username}&session=${sessionId}`;
                const response = await fetch(url);

                if (!response.ok) {
                    throw new Error(`HTTP status ${response.status}`);
                }

                const data = await response.json();

                if (data?.isSessionValid === false) {
                    handleLogout();
                    alert(
                        'For your security, you have been automatically logged out. Please log in again to continue.'
                    );
                }
            } catch (error) {
                console.error(
                    '[Session Check] Error validating session:',
                    error
                );
            }
        };

        checkSessionValidity();

        // Optional: check session every 10 mins
        const intervalId = setInterval(checkSessionValidity, 10000);

        return () => clearInterval(intervalId);
    }, [username]);
    //End Validation Session Code

    // ✅ Disable page scroll when popup is open

    const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 840);
    const location = useLocation();

    useEffect(() => {
        const handleResize = () => {
            setIsDesktop(window.innerWidth >= 840);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        document.body.style.overflow = activeModal ? 'hidden' : 'auto';
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [activeModal]);

    const isAppPromotion = location.pathname.startsWith('/app-promotion');

    useEffect(() => {
        const open = () => setShowPromoSlot(true);

        window.addEventListener('openPromoSlot', open);

        return () => window.removeEventListener('openPromoSlot', open);
    }, []);

    if (isDesktop && isAppPromotion) {
        return <Navigate to="/" replace />;
    }
    return (
        <>
            {!isAppPromotion && !showPromoSlot && (
                <PromoSlotModal onClose={() => setShowPromoSlot(false)} />
            )}
            {ActiveModal && (
                <ActiveModal closeModal={() => setActiveModal('')} />
            )}
            {/* {!isAppPromotion && <PopupBanner />} */}

            {showJiliRush &&
                createPortal(
                    isLoading ? (
                        <CandyLoadingPage
                            onLoadingComplete={() => setIsLoading(false)}
                        />
                    ) : (
                        <JiliRushGame onClose={() => setShowJiliRush(false)} />
                    ),
                    document.body
                )}

            <main className="main-container all-p age-main-container-min-height">
                {!isAppPromotion && (
                    <>
                        <TopHeaderNav />
                        <div className="search-bar-homepage">
                            <SearchGamesLibrary />
                        </div>
                    </>
                )}

                <div className="main-body main-container-global-adjusted-padding">
                    {!isAppPromotion && <MainNav />}
                    <div className="main-body-section">
                        <Routes>
                            {routes.map((route, index) => (
                                <Route
                                    key={index}
                                    path={route.path}
                                    element={route.element}
                                />
                            ))}
                        </Routes>

                        {!isAppPromotion && <SideContainer />}
                    </div>
                    {!isAppPromotion && (
                        <>
                            <Footer />
                            <FeaturedPromoMobile />
                            <LiveChat />
                        </>
                    )}
                </div>
            </main>
        </>
    );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <GlobalProvider>
        <ScheduleProvider>
            <LeaderboardProvider>
                <LeaderboardJDBWinnerLeague>
                    <BrowserRouter>
                        <RootContent />
                    </BrowserRouter>
                </LeaderboardJDBWinnerLeague>
            </LeaderboardProvider>
        </ScheduleProvider>
    </GlobalProvider>
);
